import { useRef } from "react";

export function useUserEditTracker() {
  const isUserEditedRef = useRef(false);

  const markEdited = () => {
    isUserEditedRef.current = true;
  };

  const resetEdited = () => {
    isUserEditedRef.current = false;
  };

  return {
    isUserEditedRef,
    markEdited,
    resetEdited,
  };
}
